// Default (only show contacts owned by user)
export const CONTACTS_ACCESS_OWNED_ONLY = 1
// Show all company contacts
export const CONTACTS_ACCESS_EVERYONE = 3
// Show contacts owned by the ring group users where this user is part of
export const CONTACTS_ACCESS_RING_GROUP_USERS = 4
